<!-- El wrapper se renderiza siempre: `topbar.component.ts` anima el `firstChild` de cada hijo
     del grupo derecho, y un ancla de `@if` no es un elemento. -->
<div>

    @if(venueLayout.venueConfigs.enabled()) {

        <app-venue-layout-button/>

        <app-venue-layout-container/>

    }

</div>
